import {
  Button,
  Card,
  CardContent,
  createStyles,
  Typography,
  withStyles,
  WithStyles
} from "@material-ui/core";
import React, { useEffect, useState } from "react";

import TmsInput from "../../../../components/inputs/TmsInput";
import getErrorMessage from "../../../../helpers/getErrorMessage";
import ExternalApiKeyField from "./components/inputs/ExternalApiKeyField";

const SAVE_ERROR = "Couldn't save the TMS.";

const styles = () =>
  createStyles({
    title: {
      fontWeight: 600,
      marginBottom: 8
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 8
    },
    apiKey: {
      marginTop: 16
    }
  });

interface Props extends WithStyles<typeof styles> {
  factoringId: string;
  savedTmsId: string;
  canEdit: boolean;
  onSave: (tms: string) => Promise<void>;
  openSnackbar: (variant: string, message: string) => void;
}

const TmsCard = ({
  classes,
  factoringId,
  savedTmsId,
  canEdit,
  onSave,
  openSnackbar
}: Props): JSX.Element => {
  const [tms, setTms] = useState(savedTmsId);
  const [isSaving, setSaving] = useState(false);

  useEffect(() => {
    setTms(savedTmsId);
  }, [savedTmsId]);

  const save = async (): Promise<void> => {
    setSaving(true);
    try {
      await onSave(tms);
      openSnackbar("success", "TMS saved");
    } catch (error) {
      openSnackbar("error", getErrorMessage(error, SAVE_ERROR));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" className={classes.title}>
          Transport Management Software
        </Typography>
        <TmsInput
          value={tms}
          disabled={!canEdit || isSaving}
          onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
            setTms(event.target.value)
          }
          onBlur={(): void => undefined}
          setFieldValue={(field: string, value: string): void => setTms(value)}
        />
        {canEdit && (
          <div className={classes.actions}>
            <Button
              variant="contained"
              color="primary"
              disabled={tms === savedTmsId || isSaving}
              onClick={save}
            >
              Save
            </Button>
          </div>
        )}
        {savedTmsId && (
          <div className={classes.apiKey}>
            <ExternalApiKeyField
              factoringId={factoringId}
              configuredTmsId={savedTmsId}
              openSnackbar={openSnackbar}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(TmsCard);
